module.exports = __webpack_public_path__ + "resource/img/404.d173716d.png";